document.addEventListener("DOMContentLoaded", function () {

  const LINE_LIMIT = 4;

  document.querySelectorAll(".metafield-rich_text_field").forEach(function (element) {

    if (element.dataset.readmore === "true") return;

    element.classList.add("read-more-collapsed");

    const button = document.createElement("button");
    button.className = "read-more-btn";
    button.type = "button";
    button.textContent = "Read More";

    element.insertAdjacentElement("afterend", button);

    // Only show button if content actually overflows
    if (element.scrollHeight <= element.clientHeight + 2) {
      button.style.display = "none";
      element.classList.remove("read-more-collapsed");
      return;
    }

    button.addEventListener("click", function () {

      const collapsed = element.classList.contains("read-more-collapsed");

      if (collapsed) {
        element.classList.remove("read-more-collapsed");
        button.textContent = "Read Less";
      } else {
        element.classList.add("read-more-collapsed");
        button.textContent = "Read More";
      }

    });

    element.dataset.readmore = "true";

  });

});